import React from 'react';
import { buildKey } from '@yme/utils/common';
import { View360Image } from './View360Image';
import { ListItemStyled, ListStyled } from './styled';
export function View360ImagesList({ images, onMouseDown, onTouchMove, onTouchStart, currentImageIndex, }) {
    const isVisible = (index) => currentImageIndex === index;
    return (React.createElement(ListStyled, null, images.length &&
        images.map((image, index) => (React.createElement(ListItemStyled, { onTouchMove: onTouchMove, onTouchStart: onTouchStart, onMouseDown: onMouseDown, key: buildKey(index, image.url), isVisible: isVisible(index), "data-testid": "View360ImagesList_list_item" },
            React.createElement(View360Image, { url: image.url, altText: image.label }))))));
}
